import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({ providedIn: 'root' })
export class ApiBuilderService {
  role: any;
  language = 'fa';
  acceptLang = 'fa-IR';
  constructor(private http: HttpClient) {
  }

  get<T, D = {}>(url: string, params?: D): Observable<T> {
    return this.http.get<T>(`${environment.baseUrl}${url}`, {
      headers: this.headers,
      params: params as unknown as HttpParams,
    });
  }

  getText<T, D = {}>(url: string, params?: D): Observable<T> {
    return this.http.get<T>(`${environment.baseUrl}${url}`, {
      params: params as unknown as HttpParams,
      responseType: 'arraybuffer' as any,
    });
  }
  post<T, D = {}>(url: string, data?: D): Observable<T> {
    return this.http.post<T>(`${environment.baseUrl}${url}`, JSON.stringify(data),
        {
          headers: this.headers,
        }
    );
  }
  patch<T, D = {}>(url: string, data?: D): Observable<T> {
    return this.http.patch<T>(`${environment.baseUrl}${url}`, data);
  }
  postFormData<T, D = {}>(url: string, data?: any): Observable<T> {
    const formData = new FormData();
    for (const key in data) {
      if (key.includes('File')){
        formData.append(key,(data[key]));
      }
      else if(!key.includes('File') ){
        formData.append(key, JSON.stringify(data[key]));
      }
    }
    return this.http.post<T>(`${environment.baseUrl}${url}`, formData, {
      headers: this.formDataHeaders,
    });
  }

  put<T, D>(url: string, data: D): Observable<T> {
    return this.http.put<T>(
      `${environment.baseUrl}${url}`,
      JSON.stringify(data),
      {
        headers: this.headers,
      }
    );
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${environment.baseUrl}${url}`, {
      headers: this.headers,
    });
  }

  get headers(): HttpHeaders {
    this.languageAccept();
    const headersConfig = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    return new HttpHeaders(headersConfig);
  }

  get formDataHeaders(): HttpHeaders {
    this.languageAccept();
    const headersConfig = {
      'Content-Type': 'multipart/form-data',
      Accept: 'multipart/form-data',
      'Accept-Language': this.acceptLang
    };

    return new HttpHeaders(headersConfig);
  }
  languageAccept(){
    this.language = localStorage.getItem('language');
    if(this.language && this.language === 'fa'){
      this.acceptLang = 'fa';
    }
    else{
      this.acceptLang = this.language === 'fa' ? 'fa-IR' : 'en-US,en;q=0.5';
    }
  }
}
